import { useEffect, useState } from 'react';
import { FormTemplateAPI } from '../../../api/FormTemplateAPI';
import styles from '../../../styles/modules/Registration.module.css';
import CustomContainerLoader from '../../CustomComponents/CustomContainerLoader/CustomContainerLoader';
import CustomSwitch from '../../CustomComponents/CustomSwitch/CustomSwitch';

const FormWaiver = ({ formTemplateId, waiverDetails, setWaiverDetails, setTotalWaiver }) => {
    const [waiverList, setWaiverList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const findAllWaiver = async () => {
        try {
            setIsLoading(true);
            const response = await FormTemplateAPI.getAllAttachedWaiver(formTemplateId);
            setWaiverList(response.Data);
            setTotalWaiver(response?.Data?.length);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        findAllWaiver();
    }, [])
    const handleCOllectData = (index, val, waiver) => {
        setWaiverDetails(prev => {
            let newObj = [...prev];
            if(val){
                newObj[index] = waiver;
            }else{
                newObj=newObj.filter(item=>item.id !== waiver.id);
            }
            return newObj;
        })
    };
    if (isLoading) {
        return <CustomContainerLoader />
    }


    return (
        <div className={styles['form_waiver_container']}>
            <h2>Accept Waiver</h2>
            <div className={styles['form_waiver_list']}>
                {waiverList?.map((waiver, index) =>
                    <div key={index} className={styles['form_waiver_card']}>
                        <div className={styles['form_waiver_body']}>
                            <h3>{waiver?.name}</h3>
                            <CustomSwitch checked={waiverDetails?.some(w=>w.id===waiver.id)} onChange={(event) => handleCOllectData(index, event.target.checked, waiver)} />
                        </div>
                        <p>{waiver?.desc}</p>
                    </div>)}
            </div>
        </div>
    )
}

export default FormWaiver